// Constants
import { SERVICE_DOMAINS } from '../constants/services';

// Utilities
import { request } from '../utilities/http';

// Services
export interface INetworkInitializeRequest {
  params: { networkId: string };
}

export type INetwork = {
  networkId: string;
  name: string;
  alias: string;
  publicAccess: boolean;
  photoUrl: string | null;
};
export type IPerson = {
  userId: string;
  created: string;
  firstName: string;
  lastName: string;
  email: string;
  mobile: string;
  description: string;
  photoUrl: string;
  role: 'USER' | 'ADMIN';
};

export interface INetworkInitializeResponse {
  network: INetwork;
  person: IPerson;
}

export function networkInitialize({
  params
}: INetworkInitializeRequest): Promise<INetworkInitializeResponse> {
  return request(
    `${SERVICE_DOMAINS.API}/v1/${params.networkId}/networks.initialize`,
    {
      method: 'GET'
    }
  );
}

export interface INetworkValidateRequest {
  query: { alias: string; accessKey?: string };
}

export interface INetworkValidateResponse {
  networkId: string;
  name: string;
  alias: string;
  description: string;
  publicAccess: boolean;
  created: string;
}

export function networkValidate({
  query
}: INetworkValidateRequest): Promise<INetworkValidateResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/networks.validate`, {
    method: 'GET',
    query
  });
}

export interface INetworkJoinRequest {
  params: { networkId: string };
  body: { accessKey: string };
}

export interface INetworkJoinResponse {}

export function networkJoin({
  params,
  body
}: INetworkJoinRequest): Promise<INetworkJoinResponse> {
  return request(
    `${SERVICE_DOMAINS.API}/v1/${params.networkId}/networks.join`,
    {
      method: 'POST',
      body: JSON.stringify(body)
    }
  );
}

// export interface IGetNetworkRequest {
//     params: { networkId: string };
// }
//
// export interface IGetNetworkResponse {
//     networkId: string;
//     name: string;
//     alias: string;
//     description: string;
//     publicAccess: boolean;
//     accessKey: string;
//     created: string;
// }
//
// export function getNetwork({ params }: IGetNetworkRequest): Promise<IGetNetworkResponse> {
//     return request(`${SERVICE_DOMAINS.API}/v1/${params.networkId}/networks.get`, {
//         method: 'GET'
//     });
// }

export interface ICreateNetworkRequest {
  body: {
    name: string;
    alias: string;
    description: string;
    publicAccess: boolean;
    accessKey: string;
  };
}

export interface ICreateNetworkResponse {
  networkId: string;
  name: string;
  alias: string;
  description: string;
  publicAccess: boolean;
  accessKey: string;
}

export function createNetwork({
  body
}: ICreateNetworkRequest): Promise<ICreateNetworkResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/networks.create`, {
    method: 'POST',
    body: JSON.stringify(body)
  });
}

export interface IGetNetworkExtendedRequest {
  params: { networkId: string };
}

export interface IGetNetworkExtendedResponse {
  networkId: string;
  name: string;
  alias: string;
  description: string;
  publicAccess: boolean;
  accessKey: string;
  created: string;
  photoUrl: string | null;
}

export function getNetworkExtended({
  params
}: IGetNetworkExtendedRequest): Promise<IGetNetworkExtendedResponse> {
  return request(
    `${SERVICE_DOMAINS.API}/v1/${params.networkId}/networks.get.extended`,
    {
      method: 'GET'
    }
  );
}

export interface IEditNetworkAdministrationRequest {
  params: { networkId: string };
  body: {
    name?: string;
    alias?: string;
    description?: string;
    publicAccess?: boolean;
    accessKey?: string;
  };
}

export interface IEditNetworkAdministrationResponse {
  networkId: string;
  name: string;
  alias: string;
  description: string;
  publicAccess: boolean;
  accessKey: string;
  created: string;
}

export function editNetwork({
  params,
  body
}: IEditNetworkAdministrationRequest): Promise<
  IEditNetworkAdministrationResponse
> {
  return request(
    `${SERVICE_DOMAINS.API}/v1/${params.networkId}/networks.edit`,
    {
      method: 'POST',
      body: JSON.stringify(body)
    }
  );
}

export interface IHomeListRequest {
  params: { networkId: string };
}

export interface IHomeListResponse {
  activeFrom: string;
  activeTo: string;
  authorFirstName: string;
  authorLastName: string;
  authorUserId: string;
  authorPhotoUrl: string;
  created: string;
  description: string;
  networkId: string;
  questionId: string;
  recipientCount: number;
  networkName: string;
  commentCount: number;
}

export function homeList({
  params
}: IHomeListRequest): Promise<IHomeListResponse[]> {
  return request(`${SERVICE_DOMAINS.API}/v1/${params.networkId}/home.list`, {
    method: 'GET',
    query: {
      offset: 0,
      limit: 50
    }
  });
}

export interface INetowrkUploadPhotoRequest {
  params: { networkId: string };
  body: { base64: string };
}

export interface INetowrkUploadPhotoResponse {
  photoUrl: string;
}

export function networkUploadPhoto({
  params,
  body
}: INetowrkUploadPhotoRequest): Promise<INetowrkUploadPhotoResponse> {
  return request(
    `${SERVICE_DOMAINS.API}/v1/${params.networkId}/networks.avatar.upload`,
    {
      method: 'POST',
      body: JSON.stringify(body)
    }
  );
}

export interface INetowrkDeletePhotoRequest {
  params: { networkId: string };
}

export interface INetowrkDeletePhotoResponse {}

export function networkDeletePhoto({
  params
}: INetowrkDeletePhotoRequest): Promise<INetowrkDeletePhotoResponse> {
  return request(
    `${SERVICE_DOMAINS.API}/v1/${params.networkId}/networks.avatar.delete`,
    {
      method: 'GET'
    }
  );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/network.ts